import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Tab } from '../../internal/Tab';
import { clsx } from 'clsx';
import styles from './TabsList.module.css';
import { useDeviceType } from '../../../responsive';
import { COUNTER_MAX_LENGTH_DEFAULT, LABEL_COLORS_DEFAULT, SIZE_BY_DEVICE_TYPE, TEST_ID } from '../../constants';
import { useActiveIndicatorChange } from './hooks';
import { jsx as _jsx } from "react/jsx-runtime";
export const TabsList = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    items,
    animated,
    activeTabIndex,
    labelColors = LABEL_COLORS_DEFAULT,
    counterType,
    counterMaxLength = COUNTER_MAX_LENGTH_DEFAULT,
    rightItem,
    size,
    dataTestId = TEST_ID,
    onTabClick
  } = _ref;
  const deviceType = useDeviceType();
  useActiveIndicatorChange({
    containerRef: ref,
    activeTabIndex
  });
  const handleTabClick = React.useCallback((event, index) => {
    event.currentTarget.scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest'
    });
    onTabClick(index);
  }, [onTabClick]);
  const handleKeyDown = React.useCallback((event, index) => {
    if (event.code === 'Space') {
      handleTabClick(event, index);
    }
  }, [handleTabClick]);
  return /*#__PURE__*/_jsx("ul", {
    className: clsx(styles['tabs'], {
      [styles['tabs--animated']]: animated
    }),
    ref: ref,
    "data-testid": dataTestId,
    children: items.map((tab, index) => /*#__PURE__*/_jsx(Tab, _objectSpread(_objectSpread({}, tab), {}, {
      labelColors: tab.labelColors || labelColors,
      counterType: tab.counterType || counterType,
      isActive: activeTabIndex === index,
      size: size || SIZE_BY_DEVICE_TYPE[deviceType],
      rightItem: tab.rightItem || rightItem,
      counterMaxLength: counterMaxLength,
      onClick: e => handleTabClick(e, index),
      onKeyDown: e => handleKeyDown(e, index)
    }), index))
  });
});
TabsList.displayName = 'TabsList';